// auth.js
export const LOGOUT = 'LOGOUT'
export const SAVE_TOKEN = 'SAVE_TOKEN'
export const FETCH_USER = 'FETCH_USER'
export const FETCH_USER_SUCCESS = 'FETCH_USER_SUCCESS'
export const FETCH_USER_FAILURE = 'FETCH_USER_FAILURE'
export const UPDATE_USER = 'UPDATE_USER'

export const FETCH_USERS_ALLOWED = 'FETCH_USERS_ALLOWED'
export const FETCH_USERS_ALLOWED_SUCCESS = 'FETCH_USERS_ALLOWED_SUCCESS'
export const FETCH_USERS_ALLOWED_FAILURE = 'FETCH_USERS_ALLOWED_FAILURE'

export const FETCH_GROUPS_MODERATING = 'FETCH_GROUPS_MODERATING'
export const FETCH_GROUPS_MODERATING_SUCCESS = 'FETCH_GROUPS_MODERATING_SUCCESS'
export const FETCH_GROUPS_MODERATING_FAILURE = 'FETCH_GROUPS_MODERATING_FAILURE'

export const FETCH_SURVEYS_MEMBERING                  = 'FETCH_SURVEYS_MEMBERING'
export const FETCH_SURVEYS_MEMBERING_SUCCESS          = 'FETCH_SURVEYS_MEMBERING_SUCCESS'
export const FETCH_SURVEYS_MEMBERING_FAILURE          = 'FETCH_SURVEYS_MEMBERING_FAILURE'

export const FETCH_SURVEY_FILLABLE                  = 'FETCH_SURVEY_FILLABLE'
export const FETCH_SURVEY_FILLABLE_SUCCESS          = 'FETCH_SURVEY_FILLABLE_SUCCESS'
export const FETCH_SURVEY_FILLABLE_FAILURE          = 'FETCH_SURVEY_FILLABLE_FAILURE'

export const FETCH_BACKEND_SURVEYS_ALLOWED          = 'FETCH_BACKEND_SURVEYS_ALLOWED'
export const FETCH_BACKEND_SURVEYS_ALLOWED_SUCCESS  = 'FETCH_BACKEND_SURVEYS_ALLOWED_SUCCESS'
export const FETCH_BACKEND_SURVEYS_ALLOWED_FAILURE  = 'FETCH_BACKEND_SURVEYS_ALLOWED_FAILURE'

export const FETCH_BACKEND_SURVEY_ALLOWED           = 'FETCH_BACKEND_SURVEY_ALLOWED'
export const FETCH_BACKEND_SURVEY_ALLOWED_SUCCESS   = 'FETCH_BACKEND_SURVEY_ALLOWED_SUCCESS'
export const FETCH_BACKEND_SURVEY_ALLOWED_FAILURE   = 'FETCH_BACKEND_SURVEY_ALLOWED_FAILURE'

// lang.js
export const SET_LOCALE = 'SET_LOCALE'
